import { render } from "./KonfiguracjaGry.vue?vue&type=template&id=11be6ddb&scoped=true"
import script from "./KonfiguracjaGry.vue?vue&type=script&lang=js"
export * from "./KonfiguracjaGry.vue?vue&type=script&lang=js"

import "./KonfiguracjaGry.vue?vue&type=style&index=0&id=11be6ddb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11be6ddb"]])

export default __exports__